import { mountVueComponents } from "../mounts"

mountVueComponents()
